<template>
    <span>
        
        <div class="bgimg-1 w3-display-container " v-on:click="goIntro()">
            <div class="w3-display-bottommiddle w3-padding-32" style="white-space:nowrap;">
               
                
                <div style="" class="title-text w3-center">
                    CsavarGo
                </div>
                
                <div class="w3-center w3-text-white w3-large font-1" style="letter-spacing: 1px;">felvidéki csavargások</div>
                <div class="w3-center w3-text-white w3-padding">
                    <font-awesome-icon icon="hiking" size="3x"></font-awesome-icon>                    
                    &nbsp;
                    <font-awesome-icon icon="bicycle" size="3x"></font-awesome-icon>                    
                    &nbsp;                    
                    <font-awesome-icon icon="walking" size="3x"></font-awesome-icon>
                </div>                 
                
            </div>
            <div class="w3-display-bottommiddle" style="white-space:nowrap;">           
            </div>
        </div>
        <!--
        <div class="bgimg-1 flex-center-container" v-on:click="goIntro()">
            <div class="w3-bottom w3-center" style="margin-bottom:30px;">
                <img src="../assets/img/csgo-logo-feher.png" style="width:90%; max-width:500px;">
            </div>
        </div> 
        -->  
    </span>
</template>

<script>
export default {
  name: 'Home',
  data() {
      return {
      }
  },
  methods: {
    goIntro(){
        this.$router.push('/intro');
    },
  },
}
</script>



<style>

</style>


